'use strict';

Object.defineProperty(exports, "__esModule", {
      value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Toaster = function (_React$Component) {
      _inherits(Toaster, _React$Component);

      function Toaster() {
            _classCallCheck(this, Toaster);

            return _possibleConstructorReturn(this, (Toaster.__proto__ || Object.getPrototypeOf(Toaster)).apply(this, arguments));
      }

      _createClass(Toaster, [{
            key: 'render',
            value: function render() {
                  return _react2.default.createElement(
                        Svg,
                        { width: '26', height: '32', viewBox: '0 0 26 32' },
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M22.35 18.927c0.237 0 0.396-0.158 0.396-0.396v-1.464c0-0.237-0.158-0.396-0.396-0.396s-0.396 0.158-0.396 0.396v1.464c0 0.198 0.158 0.396 0.396 0.396z' }),
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M21.203 21.38c0 0.633 0.514 1.147 1.147 1.147s1.147-0.514 1.147-1.147c0-0.633-0.514-1.147-1.147-1.147s-1.147 0.514-1.147 1.147zM22.706 21.38c0 0.198-0.158 0.356-0.356 0.356s-0.356-0.158-0.356-0.356 0.158-0.356 0.356-0.356 0.356 0.158 0.356 0.356z' }),
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M19.146 9.908h-12.698c-3.56 0-6.448 2.888-6.448 6.448v11.234c0 0.237 0.158 0.396 0.396 0.396h1.464v0.277c0 0.672 0.435 1.187 1.028 1.187h3.323c0.554 0 1.029-0.554 1.029-1.187v-0.277h10.522v0.277c0 0.672 0.435 1.187 1.029 1.187h3.362c0.554 0 1.029-0.554 1.029-1.187v-0.277h2.017c0.237 0 0.396-0.158 0.396-0.396v-11.234c0-3.56-2.888-6.448-6.448-6.448zM6.448 28.263c0 0.237-0.119 0.396-0.237 0.396h-3.362c-0.079 0-0.237-0.158-0.237-0.396v-0.277h3.798v0.277zM22.35 28.263c0 0.237-0.119 0.396-0.237 0.396h-3.362c-0.079 0-0.237-0.158-0.237-0.396v-0.277h3.798v0.277zM24.803 27.155h-24.012v-10.799c0-3.125 2.532-5.657 5.657-5.657h12.698c3.125 0 5.657 2.532 5.657 5.657v10.799z' }),
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M19.106 11.846h-12.579c-0.237 0-0.396 0.158-0.396 0.396v1.305c0 0.237 0.158 0.396 0.396 0.396h12.579c0.237 0 0.396-0.158 0.396-0.396v-1.305c0-0.237-0.198-0.396-0.396-0.396zM18.711 13.152h-11.788v-0.514h11.788v0.514z' }),
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M8.624 5.082c-0.91 0-1.661 0.752-1.661 1.661s0.752 1.661 1.661 1.661c0.237 0 0.396-0.158 0.396-0.396s-0.158-0.396-0.396-0.396c-0.475 0-0.87-0.396-0.87-0.87s0.396-0.87 0.87-0.87c0.91 0 1.661-0.752 1.661-1.661s-0.752-1.661-1.661-1.661c-0.237 0-0.396 0.158-0.396 0.396s0.158 0.396 0.396 0.396c0.475 0 0.87 0.396 0.87 0.87s-0.396 0.87-0.87 0.87z' }),
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M13.014 5.082c-0.91 0-1.661 0.752-1.661 1.661s0.752 1.661 1.661 1.661c0.237 0 0.396-0.158 0.396-0.396s-0.158-0.396-0.396-0.396c-0.475 0-0.87-0.396-0.87-0.87s0.396-0.87 0.87-0.87c0.91 0 1.661-0.752 1.661-1.661s-0.752-1.661-1.661-1.661c-0.237 0-0.396 0.158-0.396 0.396s0.158 0.396 0.396 0.396c0.475 0 0.87 0.396 0.87 0.87s-0.356 0.87-0.87 0.87z' }),
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M17.445 5.082c-0.91 0-1.661 0.752-1.661 1.661s0.752 1.661 1.661 1.661c0.237 0 0.396-0.158 0.396-0.396s-0.158-0.396-0.396-0.396c-0.475 0-0.87-0.396-0.87-0.87s0.396-0.87 0.87-0.87c0.91 0 1.661-0.752 1.661-1.661s-0.752-1.661-1.661-1.661c-0.237 0-0.396 0.158-0.396 0.396s0.158 0.396 0.396 0.396c0.475 0 0.87 0.396 0.87 0.87s-0.396 0.87-0.87 0.87z' })
                  );
            }
      }]);

      return Toaster;
}(_react2.default.Component);

Toaster.propTypes = {
      fill: _react2.default.PropTypes.string
};

exports.default = Toaster;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/toaster.js
// module id = 1127
// module chunks = 0